import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { MaterialConfiguration } from 'app/core/components/workflow-new/material/configurations/material-configuration';


@Component({
  selector: 'itpx-deliverable-tile-invalid',
  templateUrl: './deliverable-tile-invalid.component.html',
  styleUrls: ['../deliverable-tile-loading/deliverable-tile-loading.component.css', '../../common/style.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DeliverableTileInvalidComponent implements OnInit {
  @Input() props: any;
  @Input() conf: MaterialConfiguration;
  private imageWidth: string;
  private imageHeight: string;
  constructor() { }

  ngOnInit() {
    Object.assign(this, this.conf);
  }

}



// WEBPACK FOOTER //
// ./src/app/core/components/workflow-new/material/deliverable-tile-invalid/deliverable-tile-invalid.component.ts